// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"highlight_highlighted__3L2Ts"};